import { ActionType, createAction } from 'typesafe-actions'
import { MessageState } from '../../types'
import { EditMessageActionState } from './types'

export const editMessageAction = createAction('@message/EDIT_MESSAGE')<EditMessageActionState>()

const success = (state: MessageState, action: ActionType<typeof editMessageAction>): MessageState => {
  return {
    ...state,
    editMessage: action.payload.editMessage
  }
}

export const editMessageHandle = { asyncAction: editMessageAction, success }
